import { render, staticRenderFns } from "./scoreLineDetail.vue?vue&type=template&id=5f482f4e&scoped=true&"
import script from "./scoreLineDetail.vue?vue&type=script&lang=js&"
export * from "./scoreLineDetail.vue?vue&type=script&lang=js&"
import style0 from "./scoreLineDetail.vue?vue&type=style&index=0&id=5f482f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f482f4e",
  null
  
)

export default component.exports